module.exports = __webpack_public_path__ + "img/0e85e33.jpg";